import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      light: "#faf5ec",
      main: "#8aab7a",
      dark: "#5a6a40",
    },
    secondary: {
      light: "#c8b87a",
      main: "#a08060",
      dark: "#2d2a22",
    },
  },
  typography: {
    fontFamily: "'Lato', 'Roboto', Arial, sans-serif",
    h1: { fontFamily: "'Playfair Display', Georgia, serif" },
    h2: { fontFamily: "'Playfair Display', Georgia, serif" },
    h3: { fontFamily: "'Playfair Display', Georgia, serif" },
    h4: { fontFamily: "'Playfair Display', Georgia, serif" },
  },
  breakpoints: {
    values: {
      xs: 280,
      sm: 450,
      md: 760,
      lg: 920,
      xl: 1400,
    },
  },
});

export default theme;
